import { useMemo } from 'react';
import { useFeature, useFlagReady } from '@hero/web-context';

/** Stable ids for carrier profile tabs — mirrors `TABS_FOR.carrier`. */
export const CARRIER_PROFILE_TAB_IDS = [
  'general',
  'legal',
  'banking',
  'financing',
  'waybill',
] as const;

export type CarrierProfileTabId = (typeof CARRIER_PROFILE_TAB_IDS)[number];

/**
 * Carrier profile tab ids visible for the current org/session.
 * Financing is omitted until PostHog resolves `financing_module` and
 * the module is enabled — same gate as the sidebar Financing nav item.
 */
export function useCarrierProfileTabIds(): readonly CarrierProfileTabId[] {
  const financing = useFeature('financing_module');
  const financingReady = useFlagReady('financing_module');

  return useMemo(() => {
    const showFinancing = financingReady && financing.isEnabled;
    return showFinancing
      ? CARRIER_PROFILE_TAB_IDS
      : CARRIER_PROFILE_TAB_IDS.filter(id => id !== 'financing');
  }, [financingReady, financing.isEnabled]);
}
